module.exports = __webpack_public_path__ + "img/settings-outline.f682ac0a.svg";